// © Microsoft Corporation. All rights reserved.

/** Telemetry attribute name  */
export const TelemetryAttrName = "data-t";
/**
 * Telemetry event type
 * @interface TelemetryEventType
 */
export type TelemetryEventType = "UserAction" | "PageView" | "ContentView" | "AppError" | "LoadTime" | "Unload" | "Feedback" | "AdImpression" | "AdFeedback" | "VideoPlay" | "VideoAdPlay" | "ServerLog" | "AppPerfTrace" | "Auth" | "ClientLog" | "PageOutOfFocus" | "TraceInfo";

/**
 * Telemetry content view type
 * @interface TelemetryContentViewType
 */
export enum TelemetryContentViewType {
    Auto = "auto",
    AutoScroll = "autoScroll",
    Load = "load",
    Partial = "partial",
    Resize = "resize",
    Scroll = "scroll",
    Swipe = "swipe",
    Tap = "tap",
    View = "view"
}

/**
 * Dispatch event name when raising the custom page view event
 */
export const telemetryPageViewNotificationEvent = "TelemetryPageViewNotificationEvent";

/**
 * Dispatch event name when raising the custom app error event
 */
export const appErrorNotificationEvent = "AppErrorNotificationEvent";